//deprecated time in local timezone : https://stackoverflow.com/questions/12945003/format-date-as-yyyy-mm-ddthhmmss-sssz
export default function getDateTime() {
    var dateTime = new Date().toISOString();
    return dateTime;
}
